import { useMemo } from 'react';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useBreakpoints = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const isPC = useMediaQuery(theme.breakpoints.up('lg'));
  const sizes = useMemo(
    () => ({ isMobile, isPC, isTablet }),
    [isMobile, isPC, isTablet]
  );
  return { sizes, theme };
};
